import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import Tooltip from 'flarum/common/components/Tooltip';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import LangDisplayName from '../../common/utils/LangDisplayName';
import driverName from '../../common/utils/driverName';
/**
 * One-line status under content whose text has been swapped for a translation
 * in place: "Translated from German · Show original · ↻". Colours inherit from
 * the surrounding element, so it reads on tag-coloured heroes too.
 */
export default class TranslationStatus extends Component {
  view() {
    const {
      state,
      className
    } = this.attrs;
    const translation = state.active();
    if (!translation) return null;
    const source = translation.sourceLanguage() || this.attrs.source;
    return m("div", {
      className: classList('TranslationStatus', className),
      "aria-live": "polite"
    }, m(Tooltip, {
      text: this.meta(translation)
    }, m("span", {
      className: "TranslationStatus-text"
    }, m(Icon, {
      name: "fas fa-language"
    }), source ? app.translator.trans('fof-translate.forum.translation.status_from', {
      from: LangDisplayName(source)
    }) : app.translator.trans('fof-translate.forum.translation.status_text'))), m(Button, {
      className: "Button Button--link TranslationStatus-original",
      onclick: () => this.attrs.onClose ? this.attrs.onClose() : state.close()
    }, app.translator.trans('fof-translate.forum.translation.show_original_button')), this.refreshButton());
  }
  meta(translation) {
    const provider = driverName(translation.provider() ?? '');
    const updatedAt = translation.updatedAt();
    return updatedAt ? extractText(app.translator.trans('fof-translate.forum.translation.meta', {
      provider,
      time: dayjs(updatedAt).fromNow()
    })) : provider;
  }
  refreshButton() {
    const {
      state
    } = this.attrs;
    if (!app.forum.attribute('fof-translate.canRefresh')) return null;
    const label = extractText(app.translator.trans('fof-translate.forum.translation.refresh_button'));
    return m(Tooltip, {
      text: label
    }, m(Button, {
      className: "Button Button--icon Button--link TranslationStatus-refresh",
      icon: "fas fa-sync",
      "aria-label": label,
      loading: state.loading,
      disabled: state.loading,
      onclick: () => state.refresh()
    }));
  }
}
flarum.reg.add('fof-translate', 'forum/components/TranslationStatus', TranslationStatus);